import React, { useState, useCallback } from "react";
import { Button, Box, TextField, Typography, Paper } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { addPrintNotes } from "../../../api";
import { makeStyles } from "@mui/styles";
import TrackEvents from "../../../api/amplitudeEvents";
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";

const useStyles = makeStyles((theme) => ({
  fullWidth: {
    [theme.breakpoints.down("sm")]: {
      width: "100% !important",
    },
  },
}));

const Note = ({ id, setRes, setOpen }) => {
  const classes = useStyles();
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const userid = localStorage.getItem("auth_id");
  const handleChange = useCallback((e) => {
    setValue(e.target.value);
  }, []);

  const [editorState, setEditorState] = React.useState(
    EditorState.createEmpty()
  );

  const handleAddNote = async () => {
    if (!value) {
      return;
    }
    const data = new FormData();
    data.append("notesendtocustomer", id);
    data.append("userid", userid);
    data.append("notetext", value);
    try {
      setLoading(true);
      let result = await addPrintNotes(id, data);
      console.log("result from note", result);
      setRes(result.success);
      setLoading(false);
      setValue("");
      setOpen(false);
      TrackEvents(`${id}`, {
        process: "Print Note Added In Pending Order",
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    setValue(draftToHtml(convertToRaw(editorState.getCurrentContent())));
  };
  return (
    <Paper sx={{ p: 2, mt: 4, width: "70vw" }} className={classes.fullWidth}>
      <Typography
        sx={{
          mb: 2,
          color: "#3c434a",
          fontSize: "15px",
          lineHeight: "1.4em",
          fontWeight: "bold",
        }}
      >
        Add Note
      </Typography>
      {/* <TextField
        id="filled-multiline-flexible"
        multiline
        margin="dense"
        rows={4}
        value={value}
        onChange={handleChange}
        fullWidth
      /> */}
      <Editor
        editorState={editorState}
        wrapperClassName="wrapper-class"
        editorClassName="editor-class"
        toolbarClassName="toolbar-class"
        onEditorStateChange={onEditorStateChange}
        placeholder="If you want to add any other information to the mail, please add it here."
        toolbar={{
          options: ["blockType", "inline"],
          inline: {
            inDropdown: false,
            options: ["bold", "italic", "underline", "strikethrough"],
          },
          blockType: {
            inDropdown: false,
            options: ["H1", "H2", "H3", "H4", "H5", "H6", "Blockquote"],
          },
        }}
      />
      <Box display="flex" alignItems="center" justifyContent="end" mt={2}>
        <Button
          variant="contained"
          endIcon={<SendIcon />}
          disabled={loading}
          onClick={handleAddNote}
        >
          Add
        </Button>
      </Box>
    </Paper>
  );
};

export default Note;
